import { render, staticRenderFns } from "./CmsSorting.vue?vue&type=template&id=42774f52&scoped=true&"
import script from "./CmsSorting.vue?vue&type=script&lang=js&"
export * from "./CmsSorting.vue?vue&type=script&lang=js&"
import style0 from "./CmsSorting.vue?vue&type=style&index=0&id=42774f52&prod&lang=css&"
import style1 from "./CmsSorting.vue?vue&type=style&index=1&id=42774f52&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42774f52",
  null
  
)

export default component.exports